const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/problems.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/problems")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});